import $ from 'jquery';
import { trace } from 'rytm-helpers'
import { WCAG } from "rytm-wcag";
import Gallery from "blueimp-gallery";
import { initHoverMorphs } from './hover-morph'
import { updateBgPictures } from './bg-picture'
import { updateLinks } from './linksFix'

// BlueImp Gallery click
const onBlueimpGalleryLinkClick = (e) => {
  e.preventDefault();
  let blueimpLinks = document.querySelectorAll('[data-gallery]');  
  let selector = e.currentTarget.getAttribute('data-gallery');
  trace("blueimp gallery selector", selector)
  if (!selector) {
    return
  }
  let link = e.currentTarget;
  let options = {
    container: selector,
    event: e,
    index: link
  }
  Gallery(blueimpLinks, options);
}

// ### toggle class of <html> element
const onToggleClass = (e) => {
  e.preventDefault();
  const btn = e.currentTarget;
  const className = btn.dataset.toggleClass;
  if (className) {
    document.documentElement.classList.toggle(className);
  }
};
const onToggleSearch = (e) => {
  e.preventDefault();
  setTimeout(() => {
    if (document.documentElement.classList.contains("search-open")) {
      const input = document.querySelector(".global-search-form input")
      if (input) {
        input.focus()
      }
    }
  }, 100)
}
const onDismissAllClasses = (e) => {
  e.preventDefault();
  WCAG.dialogCloseAll()
  let classes = []
  const list = [...document.querySelectorAll('[data-toggle-class]')]
  list.forEach((el) => {
    const classN = el.dataset.toggleClass
    if (classes.indexOf(classN) < 0) {
      classes.push(classN)
    }
  })
  classes.forEach((className) => {
    document.documentElement.classList.remove(className);
  })
}

// ### Window update
const windowUpdateTimer = false;
export const windowUpdate = (e) => {
  updateBgPictures()
  updateLinks()
};

// ### is Mobile?
const isMobile = () => window.innerWidth <= 768;


const onPrintMe = (e) => {
  e.preventDefault();
  window.print();
}

/**
 * on collapse change txt LABEL 
 * requires:
 * toggle btn element: data-label-expanded + data-label-collapsed
 * optional:
 * an element with class="txt" (eg. span) inside the toggle btn
 */
const onCollapseChange = (e) => {
  const collapse = e.target
  const id = collapse ? collapse.id : false
  if (!id) {
    return
  }
  const btnList = [...document.querySelectorAll('a[href="#' + id + '"]')]
  btnList.forEach((btn) => {
    const labelCollapsed = btn.dataset.labelCollapsed
    const labelExpanded = btn.dataset.labelExpanded
    const txtTarget = btn.querySelector(".txt") ? btn.querySelector(".txt") : btn
    if (labelCollapsed && labelExpanded) {
      if (collapse.classList.contains("show")) {
        txtTarget.innerHTML = labelExpanded
      } else {
        txtTarget.innerHTML = labelCollapsed
      }
    }
  })
}

// ### INIT
export const initCommon = () => {
  $('body').on('click', '*[data-toggle-class]', onToggleClass);
  $('body').on('click', '.search-toggle', onToggleSearch);
  $('body').on('click', '.dismiss-all', onDismissAllClasses);
  $('body').on('click', 'a[data-gallery]', onBlueimpGalleryLinkClick);
  $('body').on('click', '.print-me', onPrintMe);
  // collapse
  $('body').on("shown.bs.collapse hidden.bs.collapse", ".collapse", onCollapseChange);
  $(document).on('DOMContentLoaded load', windowUpdate);
  $(window).on('resize', windowUpdate);
  // hover morphs
  initHoverMorphs()
  // window update
  windowUpdate();
};

